'use client'

import { useSlideshowContext } from '@fukku/slideshow/hooks/useSlideshowContext/useSlideshowContext'
import type { SlideshowFromDirection } from '@fukku/slideshow/types/Slideshow'
import { useCallback, useMemo } from 'react'
import { useStore } from 'zustand'

export const useSlideshowBullets = () => {
	const { bulletIndexStore, nItems } = useSlideshowContext()

	/* Bullet management in order to track the current item index */
	const {
		index: bulletIndex,
		firstBulletIndex,
		lastBulletIndex,
		rollLimitIndex,
	} = useStore(bulletIndexStore)

	const updateBulletsByDirection = useCallback(
		(fromDirection: SlideshowFromDirection) => {
			rollLimitIndex(fromDirection, nItems)
		},
		[rollLimitIndex, nItems]
	)

	return useMemo(
		() => ({
			bulletIndex,
			firstBulletIndex,
			lastBulletIndex,
			updateBulletsByDirection,
		}),
		[bulletIndex, firstBulletIndex, lastBulletIndex, updateBulletsByDirection]
	)
}
